import { NavLink } from "react-router-dom";
import { useAuthStore } from "../../store/auth.store";

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export function Sidebar({ isOpen, onClose }: SidebarProps) {
  const isAdmin = useAuthStore((s) => s.user?.isPanelAdmin === true);

  return (
    <aside className={`sidebar${isOpen ? " open" : ""}`}>
      <div className="sidebar-header">
        <h1>SWFIC Dashboard</h1>
        <button className="sidebar-close" onClick={onClose} aria-label="Close menu">✕</button>
      </div>
      <NavLink to="/" end className={({ isActive }) => (isActive ? "active" : "")} onClick={onClose}>
        Applications
      </NavLink>
      <NavLink to="/issues" className={({ isActive }) => (isActive ? "active" : "")} onClick={onClose}>
        Report App Issues
      </NavLink>
      {isAdmin && (
        <>
          <div className="muted" style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 0.05, padding: "12px 10px 4px" }}>
            Admin
          </div>
          <NavLink to="/apps" className={({ isActive }) => (isActive ? "active" : "")} onClick={onClose}>
            Apps
          </NavLink>
          <NavLink to="/admin/users" className={({ isActive }) => (isActive ? "active" : "")} onClick={onClose}>
            Users
          </NavLink>
          <NavLink to="/admin/backups" className={({ isActive }) => (isActive ? "active" : "")} onClick={onClose}>
            Backups
          </NavLink>
          <NavLink to="/admin/issue-types" className={({ isActive }) => (isActive ? "active" : "")} onClick={onClose}>
            Issue Types
          </NavLink>
          <a
            href="https://monitor.swfic.net"
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClose}
          >
            Monitor ↗
          </a>
        </>
      )}
    </aside>
  );
}
